import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CompleteGradingSessionResult } from "../../types/grading/PendingCorrection";

export const useCompleteGradingSession = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation<CompleteGradingSessionResult, Error, string>({
    mutationFn: async (examInstanceId: string) => {
      const response = await axios.post<CompleteGradingSessionResult>(
        `/api/grading/examinstances/${examInstanceId}/complete`
      );
      return response.data;
    },
    onSuccess: (_, examInstanceId) => {
      queryClient.invalidateQueries({ queryKey: ["pendingCorrections"] });
      queryClient.invalidateQueries({ queryKey: ["gradingLockStatus", examInstanceId] });
      queryClient.invalidateQueries({ queryKey: ["gradingSummary", examInstanceId] });
    },
  });
};

export default useCompleteGradingSession;
